import '../BotAvatar.css'
const BotAvatar = () => {
    return ( <div className='myBot'></div> );
}
 
export default BotAvatar;